import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { PageWaitComponent } from './core/inicial-componente/page-wait/page-wait.component';

//MODULO DE SEGURIDAD QUE PUEDE CAMBIAR SEGUN EL TIPO
import { AppResource } from './core/conf/app_conf';
import { AppComponent } from './core/inicial-componente/app.component';
import { BlankErrorPageComponent } from './views/pages/blank-error-page/blank-error-page.component';
import { BlankSuccessComponent } from './views/pages/blank-success/blank-success.component';
import { CreateSessionComponent } from './views/pages/create-session/create-session.component';
import { ConditionalAuthGuard } from './guards/conditional-auth.guard';
import { MedioPagoIdGuard } from './guards/medio-pago-id.guard';
import { BlankIframeComponent } from './views/blank-iframe/blank-iframe.component';
import { RedirectTbkComponent } from './views/pages/redirect-tbk/redirect-tbk.component';

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    canActivate: [ConditionalAuthGuard, MedioPagoIdGuard],
    data: {
      nombreAplicacion: () => AppResource.nombreAplicacion,
    }
  },
  {
    path: 'wait',
    component: PageWaitComponent
  },
  {
    path: 'error',
    component: BlankErrorPageComponent
  },
  {
    path: 'err',
    component: ErrorPageComponent
  },
  {
    path: 'success',
    component: BlankSuccessComponent
  },
  {
    path: 'blank-iframe',
    component: BlankIframeComponent
  },
  {
    path: 'redirecttbk',
    component: RedirectTbkComponent
  },

  {
    path: AppResource.pathSession.replace(/^\/+/, ''),
    component: CreateSessionComponent
  },
  // { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
